module.exports = __webpack_public_path__ + "img/coupon-3.e9c15641.png";